import React from "react";
import SuperAdminDashlayout from "../masterLayout/SuperAdminDashLayout";
import UserDetailspageLayer from "../components/UserDetailsPageLayer";

const UserDetailsPage = () => {
  return (
    <>
      <SuperAdminDashlayout>
        <UserDetailspageLayer />
      </SuperAdminDashlayout>
    </>
  );
};

export default UserDetailsPage;
